import {network} from '../config';

const companyContact = `${network.baseApi}/settings/contact`;
const catalogue = `${network.baseApi}/catalogue`;
const catalogueProduct = id => `${network.baseApi}/catalogue/${id}`;
const category = `${network.baseApi}/categories`;
const brand = `${network.baseApi}/brands`;
const customerOrder = (customerId, orderId) => `${network.baseApi}/customers/${customerId}/orders/${orderId}`;
const customerOrders = id => `${network.baseApi}/customers/${id}/orders`;
const customerProfile = id => `${network.baseApi}/customers/${id}/profile`;
const editCustomerProfile = id => `${network.baseApi}/customers/${id}/profile`;
const customerCart = id => `${network.baseApi}/customers/${id}/cart`;
const checkoutCart = id => `${network.baseApi}/customers/${id}/cart/checkout`;
const feedback = `${network.baseApi}/contact`;
const loginCustomer = `${network.baseApi}/login`;
const registerCustomer = `${network.baseApi}/register`;
const professionals = `${network.baseApi}/admin/professionals`;
const resourceFiles = `${network.baseApi}/files`;
const resourceFile = resourceId => `${network.baseApi}/files/${resourceId}`;
const ticketOrders = `${network.baseApi}/admin/orders/ticket`;
const subscribe = `${network.baseApi}/subscription`;

const review = `${network.baseApi}/review`;
const reviewId = id => `${network.baseApi}/review/${id}`;

// Admin Endpoints
const changeNotifications = id => `${network.baseApi}/admin/notifications/update/${id}`
const adminNotifications = `${network.baseApi}/admin/notifications`;
const loginUser = `${network.baseApi}/admin/login`;
const adminBrands = `${network.baseApi}/admin/brands`;
const adminOrder = id => `${network.baseApi}/admin/orders/${id}`;
const adminOrders = `${network.baseApi}/admin/orders`;
const adminCustomer = id => `${network.baseApi}/admin/customers/${id}`;
const adminCustomers = `${network.baseApi}/admin/customers`;
const adminProducts = `${network.baseApi}/admin/products`;
const adminProduct = id => `${network.baseApi}/admin/products/${id}`;
const adminProductVariants = id => `${network.baseApi}/admin/products/${id}/variants`;
const adminVariants = `${network.baseApi}/admin/products/variants`;
const adminVariant = (productId, variantId) => `${network.baseApi}/admin/products/${productId}/variants/${variantId}`;
const adminCustomerOrders = id => `${network.baseApi}/admin/customers/${id}/orders`;
const adminOffers = `${network.baseApi}/admin/offers`;
const adminOffer = id => `${network.baseApi}/admin/offers/${id}`;
const adminAnnouncements = `${network.baseApi}/admin/announcements`;
const adminAnnouncement = id => `${network.baseApi}/admin/announcements/${id}`;

const adminReview = `${network.baseApi}/admin/adminReviews`;
const adminReviewId = id => `${network.baseApi}/admin/adminReviews/${id}`;
// Third Party
const checkout = `${network.paymentGatewayBaseApi}/merchant/checkout`;

export default {
    companyContact,
    catalogue,
    catalogueProduct,
    category,
    brand,
    feedback,
    loginCustomer,
    registerCustomer,
    professionals,
    customerOrder,
    customerOrders,
    checkoutCart,
    customerProfile,
    editCustomerProfile,
    customerCart,
    resourceFiles,
    resourceFile,
    subscribe,
    review,
    reviewId,

    loginUser,
    adminBrands,
    adminOrder,
    adminOrders,
    adminCustomer,
    adminCustomers,
    adminProduct,
    adminProductVariants,
    adminProducts,
    adminVariants,
    adminVariant,
    adminCustomerOrders,
    adminNotifications,
    changeNotifications,
    adminAnnouncements,
    adminOffers,
    adminOffer,
    adminAnnouncement,

    adminReview,
    adminReviewId,
    checkout
};
